export default __webpack_public_path__ + "static/media/icon_assets_m.d863a44f.svg";